import React from "react";
import { StatsSummaryApp, SummaryApp } from "@appsinti/common-utils/interfaces/IApp";
import StatsSummaryPreview from "@appsinti/stats-summary-frontend/preview";
import IGroup from "@appsinti/common-utils/interfaces/IGroup";

const ComponentPicker: React.FC<{
  app: SummaryApp;
  groups: { [key: number]: IGroup };
}> = ({ app, groups }) => {

  if (app.module === "stats-summary") {
    return (
      <StatsSummaryPreview
        app={app as StatsSummaryApp}
        groups={groups}
      />
    );
  }

  return <div>App Not Supported</div>;
};

export default ComponentPicker;
